import React from "react";
import { Button } from "Components/Base/Inputs/Button";
import { FilterIcon } from "Components/Icons";

const ButtonFilter = ({ state, setState, languageContext }) => {
  return (
    <Button
      onClick={() =>
        setState((prevState) => ({
          ...prevState,
          drawerOpen: !prevState.drawerOpen,
        }))
      }
    >
      {languageContext("filter")}
      <FilterIcon />
    </Button>
  );
};

export default ButtonFilter;
